import { SapReservationsDetail } from "../../features"

const SapReservationDetailPage = () => {
  return <SapReservationsDetail />
}

export default SapReservationDetailPage
